import { HttpClient } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { DialogService } from 'src/app/utils/services/dialog.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { TipuriDocumenteService } from './tipuri-documente.service';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { AddTipuriDocumenteComponent } from './add-tipuri-documente/add-tipuri-documente.component';
import Swal from 'sweetalert2';
import { PermissionsService } from 'src/app/services/permissions.service';
import { EditTipuriDocumenteComponent } from './edit-tipuri-documente/edit-tipuri-documente.component';

@Component({
    selector: 'app-tipuri-documente',
    templateUrl: './tipuri-documente.component.html',
    styleUrls: ['./tipuri-documente.component.scss']
})
export class TipuriDocumenteComponent {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    helper = helper;

    isLoading = false;
    showCard = false;
    activeValue: string = '-1';

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    dtLink =
        environment.interop.basePath +
        environment.interop.platform.nomenclatoare.tipuriDocumente.getTipuriDocumenteDT;

    parameters: { key: string; value: string }[] = [
        { key: '--Alegeți--', value: '-1' },
        { key: 'Da', value: '1' },
        { key: 'Nu', value: '0' },
    ];

    constructor(
        private dialogService: DialogService,
        private http: HttpClient,
        private dialog: MatDialog,
        private tipuriDocumenteService: TipuriDocumenteService,
        public permissionsService: PermissionsService,
    ) { }

    resetForm() {
        this.activeValue = '-1';

        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.rerenderDT(true);
    }

    toggleCard() {
        this.showCard = !this.showCard;
    }

    ngOnInit(): void {
        this.renderDT();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            serverSide: true,
            searching: false,
            responsive: true,
            pageLength: 25,
            ajax: (dataTablesParameters: any, callback: any) => {
                dataTablesParameters.active = this.activeValue;

                this.isLoading = true;
                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'ID',
                    data: 'id',
                },
                {
                    title: 'Tip document',
                    data: 'name',
                },
                {
                    title: 'Slug',
                    data: 'slug',
                },
                {
                    title: 'Nr. zile până la arhivare',
                    data: 'archive_auto_days',
                },
                {
                    title: 'Acțiuni',
                    data: null,
                    className: 'all',
                    orderable: false,
                    render: (row: any) => {
                        return `
			                <div class="d-flex align-center justify-content-left">
                                <button class="action-btn edit ms-1">
                                    <img class="btn-img" src="../../../../assets/icons/edit.svg" alt="edit"/>
                                </button>
                                <button class="action-btn delete ms-1">
                                    <img class="btn-img" src="../../../../assets/icons/delete.svg" alt="delete"/>
                                </button>
                                <button type="button" class="action-btn update_status_active ms-1 ` +
                            (row.active == true ? 'action-success' : 'action-danger') +
                            `">
                                        <img class="btn-img" src="` +
                            (row.active == true
                                ? '/assets/icons/check-white.svg'
                                : '/assets/icons/close-white.svg') +
                            `" alt="update_status_active"/>
                                </button>
                            </div>
						`;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const editIcon = lastTd?.querySelector('.edit') as HTMLElement;
                const deleteIcon = lastTd?.querySelector('.delete') as HTMLElement;
                const updateStatusActiveIcon = lastTd?.querySelector(
                    '.update_status_active'
                ) as HTMLElement;

                if (editIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'auth-module.citizen-document-types.update'
                        )
                    ) {
                        editIcon.style.display = 'none';
                    }
                    editIcon.addEventListener('click', () => {
                        this.openEditDialog(data);
                    });
                }

                if (deleteIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'auth-module.citizen-document-types.delete'
                        )
                    ) {
                        deleteIcon.style.display = 'none';
                    }
                    deleteIcon.addEventListener('click', () => {
                        const { id } = data;
                        this.deleteTip(id);
                    });
                }

                if (updateStatusActiveIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'auth-module.citizen-document-types.update-status'
                        )
                    ) {
                        updateStatusActiveIcon.style.display = 'none';
                    }
                    updateStatusActiveIcon.addEventListener('click', () => {
                        const { id } = data;
                        this.changeStatusActive(id);
                    });
                }

                return row;
            },
        };
    }

    rerenderDT(paginate: boolean = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });
        this.showCard = false;
    }

    openAddDialog() {
        const dialogRef = this.dialog.open(AddTipuriDocumenteComponent, {
            ...this.dialogService.getDialogConfig(),
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Tip document adăugat cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    openEditDialog(data: any) {
        const dialogRef = this.dialog.open(EditTipuriDocumenteComponent, {
            ...this.dialogService.getDialogConfig(),
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Tip document actualizat cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    deleteTip(id: number) {
        Swal.fire({
            title: 'Sunteți sigur?',
            text: 'Nu o să puteți recupera datele odată cu ștergerea lor!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Confirm!',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
            showLoaderOnConfirm: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.tipuriDocumenteService.deleteTipDocumente(id).subscribe(() => {
                    this.rerenderDT();
                    Swal.fire({
                        title: 'Șters!',
                        text: 'Tip document șters cu succes.',
                        icon: 'success',
                        confirmButtonText: 'OK',
                    });
                });
            }
        });
    }

    changeStatusActive(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'O să actualizați statusul tipului de document selectat!',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.changeStatusActiveAction(id);
            }
        });
    }

    changeStatusActiveAction(id: number) {
        this.isLoading = true;
        console.log(id);
        this.tipuriDocumenteService.changeStatuseActive(id).subscribe(
            () => {
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Tip document actualizat cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            },
            (err) => {
                let msg;
                try {
                    // try to catch the message from server
                    msg = err.error.errors.message[0];
                } catch (error) {
                    // controll output message
                    msg = helper.dialogConfig.generalMessages.error;
                }
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.errorAtentie,
                    text: msg,
                    icon: 'error',
                    confirmButtonText: helper.dialogConfig.buttonLabels.retry,
                    showCancelButton: true,
                    cancelButtonText: helper.dialogConfig.buttonLabels.close,
                    reverseButtons: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.changeStatusActiveAction(id);
                    }
                });
            }
        );
    }
}
